import * as PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

const SectionWrapper = ({ className, children }) => (
  <div className={classNames('section-wrapper', className)}>{children}</div>
)

export default SectionWrapper

SectionWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}
